import { render } from "./FileIframe.vue?vue&type=template&id=5f75f03a&scoped=true&ts=true&lang=pug"
import script from "./FileIframe.vue?vue&type=script&lang=ts"
export * from "./FileIframe.vue?vue&type=script&lang=ts"

import "./FileIframe.vue?vue&type=style&index=0&id=5f75f03a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f75f03a"]])

export default __exports__